<template>
    <div class="collection-page max-content">
        <div class="top">
            <img v-if="top_url" :src="top_url" width="100%" />
        </div>
        <div class="KV">
            <img v-if="banner_url" :src="banner_url" />
        </div>
        <div class="buttons">
            <div class="one-button" @click="skip(1)">
                <img src="@/assets/images/collection/personal.png" />
                <p>个人信息维护</p>
            </div>
            <div class="one-button">
                <img src="@/assets/images/collection/report_subject.png" @click="skip(2)" />
                <p>提交讲题
                </p>
                <div class="deadline" v-if="date">
                    <img src="@/assets/images/collection/deadline.png" />
                    <p><span>{{ date.substring(0, 4) }}</span>年<span>{{ parseInt(date.substring(5, 7)) }}</span>月<span>{{ parseInt(date.substring(8, 10)) }}</span>日
                        <span>{{ time }}</span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PersoanalUserInfo } from '../../../config/interface.js'
export default {
    data() {
        return {
            id: this.$route.query.meeting_id,
            date: '',
            time: '',
            top_url: '',
            banner_url: ''
        }
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        //得到用户信息
        getUserInfo() {
            const url = PersoanalUserInfo;
            let params = {};
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        localStorage.setItem('userInfo', JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo', data);
                        this.userInfo = data;
                        if (this.userInfo && this.userInfo.mobile_status == 1) {
                            this.getDeadline();
                            // let top=this.$refs.line.getBoundingClientRect().top;
                            // let bottom=this.$refs.line.getBoundingClientRect().bottom;
                        }
                        else {
                            common.toast('未绑定手机', 1000, 'fail', () => {
                                this.$router.replace({
                                    path: '/vascularNews/user/login',
                                    query: { url: window.location.href }
                                })
                            })
                        }
                    }
                })
        },
        getDeadline() {
            const url = 'webapi/meetings/' + this.id + '/collects';
            //post必填参数，title,content，可选参数code
            let params = {};
            const method = 'GET';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.top_url = data.top_img;
                        this.banner_url = data.banner;
                        if (res.data.end_at) {
                            this.date = res.data.end_at.split(" ")[0];
                            let time = res.data.end_at.split(" ")[1];
                            time = time.split(":");
                            this.time = time[0] + ":" + time[1];

                        }
                    }
                })
        },
        skip(type) {
            switch (type) {
                case 1:
                    this.$router.push({
                        path: '/vascularNews/user/collection',
                        query: {
                            meeting_id: this.id
                        }
                    });
                    break;
                case 2:
                    this.$router.push({
                        path: '/vascularNews/subject/index',
                        query: {
                            meeting_id: this.id
                        }
                    });
                    break;

            }
        }

    }

}
</script>

<style lang="scss">
.collection-page {
    background-size: contain;
    margin-bottom: 30px;

    .top {

        // height: 53px;
        // background-color: #B01C06;
        // padding: 0 15px;
        img {
            // height: 31px;
            // vertical-align: middle;
            // margin-top: 11px;
            width: 100%;
        }
    }

    .KV {
        margin: 15px;

        img {
            width: 100%;
            border-radius: 10px;
        }
    }

    .buttons {
        display: flex;
        margin: 15px;
        flex: 1;
        flex-wrap: wrap;
        justify-content: space-between;

        .one-button {
            width: 48%;
            text-align: center;
            position: relative;

            img {
                width: 100%;
            }

            p {
                position: absolute;
                top: 55%;
                left: 50%;
                transform: translate(-50%, 0);
                color: #B01C06;
                font-size: 20px;
            }

            .deadline {
                position: absolute;
                bottom: 100%;

                img {
                    width: 90%;
                }

                p {
                    margin-top: -10px;
                    color: #A77C2E;
                    font-size: 10px;
                    white-space: nowrap;

                    span {
                        font-size: 14px;
                    }
                }

            }
        }
    }

    .tips {
        width: 80%;
        background: transparent;
        max-width: 338px;

        img {
            width: 100%;
        }

        .van-popup__close-icon--top-right {
            top: -0.1rem;
            right: 0.1rem;
        }

        p {
            position: absolute;
            margin: 30px 40px;
            top: 0;
        }

        @media (min-width: 500px) {
            p {
                font-size: 12px; //页面宽度大于640px时，字体变为16像素的1.2倍
            }
        }

        button {
            position: absolute;
            left: 0px;
            width: 68%;
            height: 46px;
            bottom: 70px;
            color: white;
            font-size: 16px;
            left: 50%;
            transform: translate(-50%, 0);
            border-radius: 10px;
            border: 2px solid rgba(255, 255, 255, 0.5);
            background: #b01c06;
            background-blend-mode: normal;
        }

        .con {
            margin: 0;
            left: 50%;
            color: white;
            text-align: center;
            bottom: 10px;
            top: auto;
            transform: translate(-50%, 0);
            white-space: nowrap;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/subject/collection.vue